export default __webpack_public_path__ + "static/media/discover_card.7fc7afa0.svg";